// AUTO-GENERATED — do not edit. Re-generated on each server startup.
// Source: mediaRegistry from system_data.json (S3)  |  Generated: 2026-05-03T11:57:37.279Z

// Full array — all active media objects
export const assetsData = [
  {
    "id": "media-1777808640333",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808640333.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.03 (6).jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:44:00.552Z"
  },
  {
    "id": "media-1777808633082",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808633082.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.03 (5).jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:43:54.389Z"
  },
  {
    "id": "media-1777808583555",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808583555.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.03 (4).jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:43:03.775Z"
  },
  {
    "id": "media-1777808564583",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808564583.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04.jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:42:45.363Z"
  },
  {
    "id": "media-1777808553691",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808553691.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04 (5).jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:42:34.732Z"
  },
  {
    "id": "media-1777808517592",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808517592.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.03 (9).jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:41:57.823Z"
  },
  {
    "id": "media-1777808498649",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808498649.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04 (3).jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:41:38.877Z"
  },
  {
    "id": "media-1777808481821",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808481821.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04 (7).jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:41:22.198Z"
  },
  {
    "id": "media-1777808465952",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808465952.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04 (1).jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:41:06.395Z"
  },
  {
    "id": "media-1777808443761",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808443761.jpeg",
    "name": "dock.jpeg",
    "status": true,
    "uploadedAt": "2026-05-03T11:40:45.116Z"
  },
  {
    "id": "media-1777629624869",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629624869.jpeg",
    "name": "  .jpeg",
    "status": true,
    "uploadedAt": "2026-05-01T10:00:24.952Z"
  },
  {
    "id": "media-1777629597626",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629597626.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04 (3).jpeg",
    "status": true,
    "uploadedAt": "2026-05-01T09:59:57.710Z"
  },
  {
    "id": "media-1777629590609",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629590609.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04 (4).jpeg",
    "status": true,
    "uploadedAt": "2026-05-01T09:59:50.697Z"
  },
  {
    "id": "media-1777629584109",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629584109.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04 (5).jpeg",
    "status": true,
    "uploadedAt": "2026-05-01T09:59:44.185Z"
  },
  {
    "id": "media-1777629577092",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629577092.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04 (6).jpeg",
    "status": true,
    "uploadedAt": "2026-05-01T09:59:37.181Z"
  },
  {
    "id": "media-1777629569517",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629569517.jpeg",
    "name": "WhatsApp Image 2026-05-01 at 03.25.04 (7).jpeg",
    "status": true,
    "uploadedAt": "2026-05-01T09:59:29.662Z"
  },
  {
    "id": "media-1777594459401",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777594459401.mp4",
    "name": "LandingPageVideoTropical.mp4",
    "status": true,
    "uploadedAt": "2026-05-01T00:14:24.003Z"
  },
  {
    "id": "media-1777593136206",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777593136206.png",
    "name": "tropical_marine_construction_logo.png",
    "status": true,
    "uploadedAt": "2026-04-30T23:52:17.158Z"
  },
  {
    "id": "media-1777593035392",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777593035392.png",
    "name": "tropical_marine_construction_logo.png",
    "status": true,
    "uploadedAt": "2026-04-30T23:50:36.313Z"
  },
  {
    "id": "media-1777551943567",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551943567.png",
    "name": "TM.png",
    "status": true,
    "uploadedAt": "2026-04-30T12:25:44.154Z"
  },
  {
    "id": "media-1777551936068",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551936068.jpg",
    "name": "BoatLifts_1.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:25:36.472Z"
  },
  {
    "id": "media-1777551933217",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551933217.jpg",
    "name": "BoatLifts_2.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:25:33.617Z"
  },
  {
    "id": "media-1777551926321",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551926321.jpg",
    "name": "BoatLifts_3.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:25:26.893Z"
  },
  {
    "id": "media-1777551923674",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551923674.jpg",
    "name": "BoatLifts_4.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:25:25.309Z"
  },
  {
    "id": "media-1777551698519",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551698519.jpg",
    "name": "BoatLifts_5.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:21:38.918Z"
  },
  {
    "id": "media-1777551696667",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551696667.jpg",
    "name": "image_6.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:21:37.256Z"
  },
  {
    "id": "media-1777551693600",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551693600.jpg",
    "name": "image_5.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:21:34.001Z"
  },
  {
    "id": "media-1777551691206",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551691206.jpg",
    "name": "image_4.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:21:31.720Z"
  },
  {
    "id": "media-1777551688083",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551688083.jpg",
    "name": "image_3.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:21:28.527Z"
  },
  {
    "id": "media-1777551675214",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551675214.jpg",
    "name": "image_4b.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:21:15.613Z"
  },
  {
    "id": "media-1777551673241",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551673241.jpg",
    "name": "image_3b.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:21:13.650Z"
  },
  {
    "id": "media-1777551666827",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551666827.jpg",
    "name": "image_3c.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:21:07.249Z"
  },
  {
    "id": "media-1777551658605",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551658605.jpg",
    "name": "image_4c.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:20:59.002Z"
  },
  {
    "id": "media-1777551656289",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551656289.jpg",
    "name": "image_3d.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:20:56.683Z"
  },
  {
    "id": "media-1777551651184",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551651184.jpg",
    "name": "image_4d.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:20:51.597Z"
  },
  {
    "id": "media-1777551649198",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551649198.jpg",
    "name": "image_3e.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:20:49.601Z"
  },
  {
    "id": "media-1777551638989",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551638989.jpg",
    "name": "image_5b.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:20:39.396Z"
  },
  {
    "id": "media-1777551637243",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551637243.jpg",
    "name": "image_4e.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:20:37.643Z"
  },
  {
    "id": "media-1777551634913",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551634913.jpg",
    "name": "image_3f.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:20:35.994Z"
  },
  {
    "id": "media-1777551617429",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551617429.jpg",
    "name": "accessories_promo.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:20:19.762Z"
  },
  {
    "id": "media-1777551610682",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551610682.jpg",
    "name": "image_7.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:20:13.146Z"
  },
  {
    "id": "media-1777551599101",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551599101.jpg",
    "name": "image_5c.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:59.524Z"
  },
  {
    "id": "media-1777551594712",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551594712.jpg",
    "name": "boatlifts_promo.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:55.115Z"
  },
  {
    "id": "media-1777551587912",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551587912.jpg",
    "name": "docks_1.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:48.375Z"
  },
  {
    "id": "media-1777551585094",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551585094.jpg",
    "name": "docks_2.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:45.482Z"
  },
  {
    "id": "media-1777551582634",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551582634.jpg",
    "name": "docks_3.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:43.040Z"
  },
  {
    "id": "media-1777551569946",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551569946.jpg",
    "name": "docks_4.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:30.345Z"
  },
  {
    "id": "media-1777551565700",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551565700.jpg",
    "name": "image_5d.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:26.093Z"
  },
  {
    "id": "media-1777551563908",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551563908.jpg",
    "name": "image_4f.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:24.947Z"
  },
  {
    "id": "media-1777551560992",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551560992.jpg",
    "name": "image_3g.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:21.390Z"
  },
  {
    "id": "media-1777551555264",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551555264.jpg",
    "name": "image_6b.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:15.662Z"
  },
  {
    "id": "media-1777551553066",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551553066.jpg",
    "name": "image_5e.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:13.460Z"
  },
  {
    "id": "media-1777551551081",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551551081.jpg",
    "name": "image_4g.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:11.479Z"
  },
  {
    "id": "media-1777551548367",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551548367.jpg",
    "name": "image_3h.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:08.763Z"
  },
  {
    "id": "media-1777551542498",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551542498.jpg",
    "name": "image_4h.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:19:02.897Z"
  },
  {
    "id": "media-1777551538397",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551538397.jpg",
    "name": "image_3i.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:18:58.819Z"
  },
  {
    "id": "media-1777551515731",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551515731.jpg",
    "name": "tropical-marine-logo.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:18:36.141Z"
  },
  {
    "id": "media-1777551506292",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551506292.jpg",
    "name": "image_3j.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:18:26.859Z"
  },
  {
    "id": "media-1777551504375",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551504375.jpg",
    "name": "image_2.jpg",
    "status": true,
    "uploadedAt": "2026-04-30T12:18:24.946Z"
  },
  {
    "id": "media-1777551501834",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551501834.png",
    "name": "google_plus_logo.png",
    "status": true,
    "uploadedAt": "2026-04-30T12:18:22.776Z"
  },
  {
    "id": "media-1777551497916",
    "image": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551497916.png",
    "name": "badge_logo.png",
    "status": true,
    "uploadedAt": "2026-04-30T12:18:18.734Z"
  }
];

// Keyed by filename for direct code access
// e.g.  import { ASSETS } from '../Public/assets-data';
//       const logo = ASSETS.FLOWMA_FULL_BLACK_1;
export const ASSETS = {
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_03_6": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808640333.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_03_5": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808633082.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_03_4": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808583555.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808564583.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_5": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808553691.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_03_9": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808517592.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_3": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808498649.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_7": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808481821.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_1": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808465952.jpeg",
  "DOCK": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777808443761.jpeg",
  "": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629624869.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_3_2": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629597626.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_4": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629590609.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_5_2": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629584109.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_6": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629577092.jpeg",
  "WHATSAPP_IMAGE_2026_05_01_AT_03_25_04_7_2": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777629569517.jpeg",
  "LANDINGPAGEVIDEOTROPICAL": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777594459401.mp4",
  "TROPICAL_MARINE_CONSTRUCTION_LOGO": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777593136206.png",
  "TROPICAL_MARINE_CONSTRUCTION_LOGO_2": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777593035392.png",
  "TM": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551943567.png",
  "BOATLIFTS_1": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551936068.jpg",
  "BOATLIFTS_2": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551933217.jpg",
  "BOATLIFTS_3": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551926321.jpg",
  "BOATLIFTS_4": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551923674.jpg",
  "BOATLIFTS_5": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551698519.jpg",
  "IMAGE_6": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551696667.jpg",
  "IMAGE_5": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551693600.jpg",
  "IMAGE_4": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551691206.jpg",
  "IMAGE_3": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551688083.jpg",
  "IMAGE_4B": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551675214.jpg",
  "IMAGE_3B": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551673241.jpg",
  "IMAGE_3C": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551666827.jpg",
  "IMAGE_4C": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551658605.jpg",
  "IMAGE_3D": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551656289.jpg",
  "IMAGE_4D": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551651184.jpg",
  "IMAGE_3E": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551649198.jpg",
  "IMAGE_5B": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551638989.jpg",
  "IMAGE_4E": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551637243.jpg",
  "IMAGE_3F": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551634913.jpg",
  "ACCESSORIES_PROMO": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551617429.jpg",
  "IMAGE_7": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551610682.jpg",
  "IMAGE_5C": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551599101.jpg",
  "BOATLIFTS_PROMO": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551594712.jpg",
  "DOCKS_1": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551587912.jpg",
  "DOCKS_2": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551585094.jpg",
  "DOCKS_3": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551582634.jpg",
  "DOCKS_4": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551569946.jpg",
  "IMAGE_5D": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551565700.jpg",
  "IMAGE_4F": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551563908.jpg",
  "IMAGE_3G": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551560992.jpg",
  "IMAGE_6B": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551555264.jpg",
  "IMAGE_5E": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551553066.jpg",
  "IMAGE_4G": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551551081.jpg",
  "IMAGE_3H": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551548367.jpg",
  "IMAGE_4H": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551542498.jpg",
  "IMAGE_3I": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551538397.jpg",
  "TROPICAL_MARINE_LOGO": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551515731.jpg",
  "IMAGE_3J": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551506292.jpg",
  "IMAGE_2": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551504375.jpg",
  "GOOGLE_PLUS_LOGO": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551501834.png",
  "BADGE_LOGO": "https://sawpy-assets.s3.us-east-2.amazonaws.com/tropicalmarine/gallery/1777551497916.png"
};

// Safe lookup — returns null when asset not yet uploaded (fresh clone).
// Pass null src to the Image component → shows skeleton placeholder.
export function getAsset(key) { return ASSETS[key] ?? null; }
